import React, { Suspense, memo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import styles from "./HomeLayout.module.scss";
import { Outlet } from "react-router-dom";
import LeftSideBar from "./LeftSideBar";
import TopBar from "./TopBar";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarOpen } from "redux/slices/homeSlice";
import ErrorBoundary from "components/shared/errorboundary/ErrorBoundary";
import {
  setLogoutModalOpen,
} from "redux/slices/globalSlice";
import { combineClasses } from "utils/utils";

const HomeLayout = () => {
  const dispatch = useDispatch();
  const { logoutModalOpen } = useSelector((state) => state.global);
  const { sidebarOpen } = useSelector((state) => state.home);


  const toggleSidebarOpen = (flag) => (e) => {
    e.stopPropagation();
    sidebarOpen !== flag && dispatch(setSidebarOpen(flag));
  };

  return (
    <div
      className={styles.layout}
      onClick={(e) => {
        logoutModalOpen && dispatch(setLogoutModalOpen(false));
      }}
    >
      <LeftSideBar toggleSidebarOpen={toggleSidebarOpen} />
      <div
        className={!sidebarOpen ? styles.rightSideContainer : combineClasses(styles.rightSideContainer, styles.sidebarClosed)}
        onMouseOver={toggleSidebarOpen(false)}
      >
        <TopBar />
        <div className={styles.outletDiv}>
          <Suspense>
            <ErrorBoundary>
              <DndProvider backend={HTML5Backend}>
                <Outlet />
              </DndProvider>
            </ErrorBoundary>
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default memo(HomeLayout);
